import { render, staticRenderFns } from "./EmployeeProfileImage.vue?vue&type=template&id=3b66e204"
import script from "./EmployeeProfileImage.vue?vue&type=script&lang=ts"
export * from "./EmployeeProfileImage.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeProfileImage.vue?vue&type=style&index=0&id=3b66e204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports